var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreeLiveClasses = function SvgFreeLiveClasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#free-live-classes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBEF",
    d: "M2.098 1.395A2.11 2.11 0 0 0 0 3.498v22.4c0 1.151.947 2.098 2.098 2.098h34.998a2.11 2.11 0 0 0 2.103-2.098v-22.4a2.116 2.116 0 0 0-2.103-2.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBEF",
    d: "M34.296 1.395c1.15 0 2.102.952 2.102 2.104v21a2.11 2.11 0 0 1-2.102 2.097H2.097A2.106 2.106 0 0 1 0 24.498v1.4c0 1.152.946 2.098 2.097 2.098h34.999a2.11 2.11 0 0 0 2.102-2.098v-22.4a2.117 2.117 0 0 0-2.102-2.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDEC8",
    d: "M6.304 29.397a3.51 3.51 0 0 0-3.503 3.498v.702a3.51 3.51 0 0 0 3.503 3.499 3.505 3.505 0 0 0 3.498-3.498v-.703a3.505 3.505 0 0 0-3.498-3.499M35.696 29.397a3.505 3.505 0 0 0-3.499 3.498v.702a3.505 3.505 0 0 0 3.499 3.499 3.51 3.51 0 0 0 3.503-3.498v-.703a3.51 3.51 0 0 0-3.503-3.499M21.17 29.75a3.505 3.505 0 0 0-3.498 3.498v.703a3.505 3.505 0 0 0 3.498 3.498 3.51 3.51 0 0 0 3.503-3.498v-.703a3.51 3.51 0 0 0-3.503-3.498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDEC8",
    d: "M6.304 29.395c-.499 0-.971.109-1.402.298a3.5 3.5 0 0 1 2.1 3.2v.703a3.5 3.5 0 0 1-2.1 3.2c.43.19.903.298 1.402.298a3.506 3.506 0 0 0 3.498-3.498v-.703a3.506 3.506 0 0 0-3.498-3.498M35.7 29.395c-.498 0-.971.109-1.401.298a3.5 3.5 0 0 1 2.1 3.2v.703a3.5 3.5 0 0 1-2.1 3.2c.43.19.903.298 1.401.298a3.506 3.506 0 0 0 3.499-3.498v-.703a3.506 3.506 0 0 0-3.499-3.498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A09EE7",
    d: "M3.5 4.195a.7.7 0 0 0-.703.703v19.6a.7.7 0 0 0 .703.697h32.197a.7.7 0 0 0 .703-.697v-19.6a.7.7 0 0 0-.703-.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FC7AF",
    d: "M4.201 35.693A4.21 4.21 0 0 0 0 39.894v1.4a.7.7 0 0 0 .703.703H11.9a.7.7 0 0 0 .703-.702v-1.4a4.21 4.21 0 0 0-4.201-4.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52565E",
    d: "M37.804 35.695A4.204 4.204 0 0 1 42 39.896v1.4a.7.7 0 0 1-.697.703H30.105a.7.7 0 0 1-.703-.702v-1.4a4.21 4.21 0 0 1 4.201-4.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A09EE7",
    d: "M23.277 36.049a4.204 4.204 0 0 1 4.196 4.2v1.401a.7.7 0 0 1-.698.703H15.578a.7.7 0 0 1-.703-.703v-1.4a4.21 4.21 0 0 1 4.201-4.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52565E",
    d: "M38.496 40.6H30.1a.7.7 0 0 1-.703-.703v1.4a.7.7 0 0 0 .703.702h11.197a.7.7 0 0 0 .703-.702v-1.402c0-2.314-1.887-4.2-4.201-4.2h-2.8a4.21 4.21 0 0 1 4.201 4.201.7.7 0 0 1-.703.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FC7AF",
    d: "M9.1 40.6H.703A.7.7 0 0 1 0 39.896v1.4a.7.7 0 0 0 .703.702H11.9a.7.7 0 0 0 .703-.702v-1.402c0-2.314-1.887-4.2-4.202-4.2h-2.8a4.21 4.21 0 0 1 4.202 4.201.7.7 0 0 1-.703.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A09EE7",
    d: "M3.499 4.195a.7.7 0 0 0-.704.703v19.6a.7.7 0 0 0 .704.697h2.8a.7.7 0 0 1-.704-.697v-18.2a.7.7 0 0 1 .704-.703h29.397a.7.7 0 0 1 .703.703v-1.4a.7.7 0 0 0-.703-.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19248",
    d: "M21.697 0A2.106 2.106 0 0 0 19.6 2.097v11.197c0 1.152.946 2.104 2.097 2.104h.697v3.498a.7.7 0 0 0 1.158.533l4.702-4.03h11.641A2.12 2.12 0 0 0 42 13.293V2.097A2.11 2.11 0 0 0 39.895 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.297 4.196v7.001a.7.7 0 0 0 1.069.595l5.601-3.499a.7.7 0 0 0 0-1.188l-5.601-3.504c-.42-.263-1.07-.008-1.07.595"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19248",
    d: "M37.096 0C38.247 0 39.2.946 39.2 2.097v9.797A2.12 2.12 0 0 1 37.096 14h-8.842l-4.702 4.03a.7.7 0 0 1-1.157-.533v1.4a.7.7 0 0 0 1.157.533l4.702-4.03h11.642A2.12 2.12 0 0 0 42 13.293V2.097A2.11 2.11 0 0 0 39.896 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FC7AF",
    d: "M9.797 19.602a4.203 4.203 0 0 0-4.201 4.194v1.399H21v-1.399a4.2 4.2 0 0 0-4.2-4.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FC7AF",
    d: "M13.998 19.602c2.315 0 4.2 1.88 4.2 4.194v1.399h2.8v-1.399a4.2 4.2 0 0 0-4.2-4.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDEC8",
    d: "M10.498 16.799v3.499q0 .08.017.16s.123.519.537.996c.414.478 1.177.94 2.247.94s1.829-.462 2.243-.94.537-.997.537-.997a.7.7 0 0 0 .016-.16V16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDEC8",
    d: "M10.498 16.799v2.733a5.54 5.54 0 0 0 2.801.764 5.53 5.53 0 0 0 2.796-.763V16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDEC8",
    d: "M9.1 11.895v2.8c0 2.316 1.886 4.2 4.2 4.2a4.203 4.203 0 0 0 4.197-4.2v-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDEC8",
    d: "M14.696 11.895v2.8a4.2 4.2 0 0 1-2.796 3.956c.44.156.909.245 1.4.245a4.203 4.203 0 0 0 4.196-4.2v-2.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A626E",
    d: "M12.598 6.996a4.21 4.21 0 0 0-4.202 4.201v2.098a.7.7 0 0 0 .703.704h2.098c1.787 0 3.633-.915 4.098-1.214l1.008 1.006c.131.133.31.207.496.208h.697a.7.7 0 0 0 .703-.704v-2.097a4.21 4.21 0 0 0-4.201-4.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A626E",
    d: "M12.598 6.996c-.239 0-.471.027-.7.064a4.21 4.21 0 0 1 3.502 4.138v1.69l.903.903c.132.133.31.207.497.208h.697a.7.7 0 0 0 .703-.704v-2.097a4.21 4.21 0 0 0-4.202-4.202z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "free-live-classes_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgFreeLiveClasses;